import { atom } from "recoil";

let today = new Date();

export const auditlogDateRangeRecoil = atom({
    key: "auditlogDateRangeRecoil",
    default: [
        {
            startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30),
            endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59),
            key: 'selection',
        },
    ],
});

export const showAuditLogsDateResetButton = atom({
    key: "showAuditLogsDateResetButton",
    default: false,
});